import { Link } from 'react-router-dom';
import type { IInvoiceRelatedLinksProps } from './types';
import { getRelatedLinkParams } from './utils';

export const InvoiceRelatedLinks = (props: IInvoiceRelatedLinksProps) => {
  const { className } = props;
  const params = getRelatedLinkParams(props);

  if (!params) return null;

  return (
    <Link to={params.path} className={className}>
      {params.text}
    </Link>
  );
};
